// @index('./*.ts', f => `export * from '${f.path}';`)
export * from './asset.module';
export * from './asset.pipe';
export * from './asset.service';
// @endindex